module.exports = __webpack_public_path__ + "img/bosspack-inactive.bbb4b90b.svg";